// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3hQlq{padding-bottom:55px}._3hQlq path,line{stroke:#000!important}::-webkit-scrollbar{height:10px}::-webkit-scrollbar-track:horizontal{border-top:.5px solid #000}::-webkit-scrollbar-thumb:horizontal{background-color:#000}", ""]);
// Exports
exports.locals = {
	"heatmap": "_3hQlq"
};
module.exports = exports;
